/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import TableHeading from '../../../../components/common/Table/TableHeading/TableHeading'
import Container from '../../../common/Container/Container'

/**
 * Class for the ClientTable header
 *
 * @export
 * @class RenewalsTableHeader
 * @extends {React.Component<any, any>}
 */
export default class RenewalsTableHeader extends React.Component<any, any> {

    /**
     * Creates an instance of RenewalsTableHeader.
     * @param {*} props
     * @memberof RenewalsTableHeader
     */
    constructor(props: any) {
        super(props)

        this.state = {
            page: 1,
            perPage: 20,
            sortedBy: 'clientName',
            sortedType: 'asc',
        }
    }

    /**
     * Trigger fot the header filters
     *
     * @memberof RenewalsTableHeader
     * @param {Object} params
     */
    filterTrigger = (params: object) => {
        this.props.filterTrigger(params)
        this.setState(params)
    }

    render() {

        /**
         * List of headings
         * @type {Array}
         */
        let listHeadings =
            [
                { title: 'Client Name', param: 'clientName' },
                { title: 'Renewal date', param: 'renewalDate' },
                { title: 'Policy no.', param: 'policyNo' },
                { title: 'Premium', param: 'premium' },
            ]

        return (

            <Container
                className={`clients__headings table__headings ${this.state.sortedBy}`}
                fullwidth={true}
                shadow={true}
            >

                <div />
                {listHeadings.map((heading, i) => (
                    <TableHeading
                        key={i}
                        noMargin={true}
                        title={heading.title}
                        param={heading.param}
                        state={this.state}
                        filterTrigger={this.filterTrigger}
                    />
                ))}

                <div className="table__title column center">Actions</div>

            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/components/RenewalsTableHeader.tsx